var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBritainFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16.5,
    r: 15.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 31.5C25.2843 31.5 32 24.7843 32 16.5C32 8.21573 25.2843 1.5 17 1.5C8.71573 1.5 2 8.21573 2 16.5C2 24.7843 8.71573 31.5 17 31.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10071 7.36768C3.92244 8.90066 3.03399 10.6676 2.51666 12.587H10.3201L5.10071 7.36768Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4832 12.587C30.9658 10.6676 30.0773 8.90067 28.8991 7.36768L23.6799 12.587H31.4832Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51666 20.4131C3.03405 22.3325 3.9225 24.0994 5.10071 25.6323L10.3199 20.4131H2.51666Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1321 4.6007C24.5991 3.42244 22.8323 2.53398 20.9128 2.0166V9.81994L26.1321 4.6007Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86761 28.3989C9.4006 29.5771 11.1675 30.4656 13.0869 30.983V23.1797L7.86761 28.3989Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0869 2.0166C11.1674 2.53398 9.40054 3.42244 7.86761 4.60064L13.0869 9.81988V2.0166Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9129 30.983C22.8323 30.4656 24.5992 29.5771 26.1321 28.3989L20.9129 23.1797V30.983Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6799 20.4131L28.8991 25.6324C30.0773 24.0995 30.9658 22.3325 31.4832 20.4131H23.6799Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.873 14.5435H18.9566H18.9566V1.62697C18.3161 1.54359 17.6631 1.5 17 1.5C16.3368 1.5 15.6839 1.54359 15.0435 1.62697V14.5434V14.5434H2.12697C2.04359 15.1839 2 15.8369 2 16.5C2 17.1632 2.04359 17.8161 2.12697 18.4565H15.0434H15.0434V31.373C15.6839 31.4564 16.3368 31.5 17 31.5C17.6631 31.5 18.3161 31.4565 18.9565 31.373V18.4566V18.4566H31.873C31.9564 17.8161 32 17.1632 32 16.5C32 15.8369 31.9564 15.1839 31.873 14.5435Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9131 20.4131L27.6066 27.1067C27.9145 26.7989 28.2081 26.4772 28.4883 26.1437L22.7577 20.4131H20.9131V20.4131Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0868 12.5873V12.5871L6.39332 5.89355C6.08546 6.20129 5.79179 6.52303 5.5116 6.85654L11.2422 12.5872H13.0868V12.5873Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9259 12.5882V12.5881L27.6194 5.89453C27.9272 6.20227 28.2209 6.524 28.5011 6.85752L22.7705 12.5882H20.9259V12.5882Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0909 20.4259V20.426L6.39734 27.1196C6.08949 26.8119 5.79582 26.4902 5.51562 26.1566L11.2463 20.426H13.0909V20.4259Z",
    fill: "#C8102E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(2 1.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(2 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBritainFlag);
export default __webpack_public_path__ + "static/media/britainFlag.f6d22c2640beba2c33e04a55442e4415.svg";
export { ForwardRef as ReactComponent };